import type { PresentationIsEmptyProps } from '../..'
export default function isEmpty({ section }: PresentationIsEmptyProps) {
  const content = section?.fields?.content

  if (!content) return true

  return false
}
